import React, { useState, useEffect, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { ThemeContext, ThemeProvider } from "./providers/ThemeProvider";
import Login from "./components/Login";
import Register from "./components/Auth/Register";
import ChatLayout from "./components/Chat/ChatLayout";
import SettingsLayout from "./components/Settings/SettingsLayout";
import NotFoundPage from "./components/404Page";
// import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";

const AppRoutes: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => {
    const savedState = sessionStorage.getItem("sidebarOpen");
    return savedState ? JSON.parse(savedState) : true;
  });
  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("App must be used within a ThemeProvider");
  }

  const { themeMode, setThemeMode, accentColor, setAccentColor } = themeContext;

  useEffect(() => {
    sessionStorage.setItem("sidebarOpen", JSON.stringify(sidebarOpen));
  }, [sidebarOpen]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected routes */}
      <Route
        path="/chat/:id"
        element={
          <ProtectedRoute>
            <ChatLayout
              sidebarOpen={sidebarOpen}
              toggleSidebar={() => setSidebarOpen((prev) => !prev)}
              themeMode={themeMode}
              setThemeMode={setThemeMode}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dms/:id"
        element={
          <ProtectedRoute>
            <ChatLayout
              sidebarOpen={sidebarOpen}
              toggleSidebar={() => setSidebarOpen((prev) => !prev)}
              themeMode={themeMode}
              setThemeMode={setThemeMode}
              fixedDatabase="regulation"
            />
          </ProtectedRoute>
        }
      />

      {/* Protected routes */}
      <Route
        path="/settings/*"
        element={
          <ProtectedRoute>
            <SettingsLayout
              sidebarOpen={sidebarOpen}
              toggleSidebar={() => setSidebarOpen((prev) => !prev)}
              themeMode={themeMode}
              setThemeMode={setThemeMode}
              accentColor={accentColor}
              setAccentColor={setAccentColor}
            />
          </ProtectedRoute>
        }
      />

      {/* Widget route */}
      <Route
        path="/widget/dms/:id"
        element={
          <ProtectedRoute>
            <ChatLayout
              sidebarOpen={false}
              toggleSidebar={() => {}}
              themeMode={themeMode}
              setThemeMode={setThemeMode}
              fixedDatabase="regulation"
              isWidget
            />
          </ProtectedRoute>
        }
      />
      <Route path="/widget/dms" element={<Navigate to="/widget/dms/new" replace />} />

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/chat/new" replace />} />
      <Route path="/dms" element={<Navigate to="/dms/new" replace />} />

      {/* 404 Page */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ThemeProvider>
        <AppRoutes />
      </ThemeProvider>
    </Router>
  );
};

export default App;
